import styled, { css } from 'styled-components'

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ContentBox = styled.div`
  flex-grow: 1;
  width: 100%;
  max-width: 650px;
  display: flex;
  flex-direction: column;
  padding: 60px 20px;
`

export const Text = styled.p<{ $bold?: boolean }>`
  ${({ theme }) => theme.textStyles.text}
  white-space: pre-wrap;
  margin-top: 20px;

  ${({ $bold }) =>
    $bold &&
    css`
      ${({ theme }) => theme.textStyles.textBold}
    `};
`
